import Http from '@/api/http.js'

export default {

  indexBrand(params) {
    return Http.get(`/brands`, {params})
  },

  createBrand(newBrand) {
    return Http.post(`/brands`, {
      brand: 
      {
        name: newBrand.name,
        segment_ids: newBrand.segment_ids,
        'contact_attributes': newBrand.contact_attributes,
        'brand_company_codes_attributes': newBrand.brand_company_codes_attributes,
        'account_attributes': newBrand.account_attributes,
        'vrt_account_attributes': newBrand.vrt_account_attributes,
      }
    })
  },

  updateBrand(updateSupplier, id) {
    return Http.put(`/brands/${id}`, {
      brand: {
        name: updateSupplier.name,
        segment_ids: updateSupplier.segment_ids,
        'contact_attributes': updateSupplier.contact_attributes,
        'brand_company_codes_attributes': updateSupplier.brand_company_codes_attributes,
        'account_attributes': updateSupplier.account_attributes,
        goals_attributes: [updateSupplier.goals_attributes],
        
        photo: updateSupplier.photo,

        'vrt_account_attributes': updateSupplier.vrt_account_attributes,
      }
    })
  },

  updateBrandInfo (params){
    return Http.put(`/brands/${params.id}`, {
      brand: {...params}
    })
  },
  updateBrandCodes (params){
    return Http.put(`/brands/${params.id}`, {
      brand: {...params}
    })
  },
  updateBrandAccount (params){
    return Http.put(`/brands/${params.id}`, {
      brand: {...params}
    })
  },

}